
import moment from 'moment/moment'
import {
  isNumber,
  isString,
  isEqual,
} from 'lodash'

export const deleteCookie = name => {
  setCookie(name, '', -1)
}

export const getCookie = name => {
  name = `${name}=`
  const cookies = decodeURIComponent(document.cookie).split(';')
  for(let i = 0, len = cookies.length; i < len; i++) {
    let cookie = cookies[i]
    while(cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if(cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }
  return ''
}

export const getPathnameEnding = pathname => {
  let pathEnding
  const pathnameComponents = pathname.split('/')
  if(Array.isArray(pathnameComponents)) {
    pathEnding = pathnameComponents.pop()
  }
  return pathEnding
}

export const setCookie = (name, value, minutesToExpiration, path='/') => {
  let cookie = `${name}=${value};`
  if(isNumber(minutesToExpiration)) {
    const d = moment()
    d.add(minutesToExpiration, 'minutes')
    cookie += `expires=${d.toDate().toUTCString()};`
  }
  cookie += `path=${path}`
  document.cookie = cookie
}

export const getQueryStrParamVal = (qs, param) => {
  let value
  const matches = qs.match(new RegExp(`${param}=([^&]+)`))
  if(Array.isArray(matches) && matches[1]) {
    value = matches[1]
  }
  return value
}

export const timeoutPromise = timeout => new Promise(resolve => {
  setTimeout(() => resolve(), timeout || 500)
})


export const filterArrayOfObjects = (arr, filter = '') => {
  if (typeof filter !== 'string') {
    throw new Error('Function requires string as filter')
  }

  filter = filter.toLowerCase()
  return arr.filter(ele => {
    const values = Object.values(ele)
    let contains = false
    for (let value of values) {
      if (contains) {
        return true
      }
      if (isString(value)) {
        contains = value.toLowerCase().includes(filter)
      } else if (isNumber(value)) {
        value = value.toString()
        contains = value.includes(filter)
      }
    }
    return contains
  })
}


/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Array}         Return a list of the the diff
 */
export const difference = (object, base) => {
  const diff = Object.keys(object).reduce((result, key) => {
      if (!base.hasOwnProperty(key)) {
          result.push(key);
      } else if (isEqual(object[key], base[key])) {
          const resultKeyIndex = result.indexOf(key);
          result.splice(resultKeyIndex, 1);
      }
      return result;
  }, Object.keys(base));

  return diff;
}



// WEBPACK FOOTER //
// ./src/utils.js